import { render } from "./AlertasSC.vue?vue&type=template&id=36766fd4&scoped=true"
import script from "./AlertasSC.vue?vue&type=script&lang=js"
export * from "./AlertasSC.vue?vue&type=script&lang=js"

import "./AlertasSC.vue?vue&type=style&index=0&id=36766fd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36766fd4"]])

export default __exports__